import { render, staticRenderFns } from "./AddNftItem.vue?vue&type=template&id=e85ff824&scoped=true&"
import script from "./AddNftItem.vue?vue&type=script&lang=ts&"
export * from "./AddNftItem.vue?vue&type=script&lang=ts&"
import style0 from "./AddNftItem.vue?vue&type=style&index=0&id=e85ff824&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ff824",
  null
  
)

export default component.exports